<div class="card">
  <div class="row">
    <div class="mb-3 text-left font-medium text-md">
      <span class="text-primary-700">
        <p-button
          icon="pi pi-arrow-left"
          [rounded]="true"
          [outlined]="true"
          severity="primary"
          [styleClass]="'back-button'"
          (click)="goToBack()"
        ></p-button>
        Detalle de Renovación
      </span>
      <span class="text-900">
        | {{ renewal.member.name }} {{ renewal.member.lastName }}
      </span>
    </div>
    <div class="flex mb-2 gap-2 justify-content-end">
      <p-button
        (click)="activeIndex = 0"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 0"
        label="1"
      ></p-button>
      <p-button
        (click)="activeIndex = 1"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 1"
        label="2"
      ></p-button>
    </div>
  </div>

  <p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-user"></i>
        <span class="ml-1"> Información de Renovación</span>
      </ng-template>

      <div class="surface-section">
        <ul class="list-none p-0 m-0">
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Tipo Solicitud</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              <p-tag
                [severity]="'info'"
                [rounded]="true"
                [value]="'Renovación'"
              />
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Estado</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              <p-tag
                [severity]="getStatusSeverity(renewal.process.processStage)"
                [rounded]="true"
                [value]="getStatusLabel(renewal.process.processStage)"
              />
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Nombre</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ renewal.member.name }}
              {{ renewal.member.lastName }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Identificación</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ renewal.member.idType }}
              {{ renewal.member.idNumber }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">ID de Renovación</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ renewal.renewalId }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Fecha de Creación</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ getHumanTime(renewal.auditData.createdDate) }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Creado Por</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ renewal.auditData.createdBy }}
            </div>
          </li>
          <li
            *ngIf="renewal.auditData.modifiedDate"
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Última Modificación</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ getHumanTime(renewal.auditData.modifiedDate) }}
            </div>
          </li>
          <li
            *ngIf="renewal.auditData.modifiedBy"
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Modificado Por</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ renewal.auditData.modifiedBy }}
            </div>
          </li>
          <li
            *ngIf="renewal.process.comments"
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Comentarios</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ renewal.process.comments }}
            </div>
          </li>
        </ul>
      </div>
    </p-tabPanel>
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-dollar"></i>
        <span class="ml-1">Información de Pago</span>
      </ng-template>
      <div class="surface-section">
        <ul class="list-none p-0 m-0">
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Monto Total</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ getRenewalAmount() | currency:'COP':'symbol-narrow':'1.0-0' }}
            </div>
          </li>
          <li
            *ngIf="renewal.payment.paymentId"
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">ID de Pago</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ renewal.payment.paymentId }}
            </div>
          </li>
          <li
            *ngIf="renewal.payment.paymentMethod"
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Método de Pago</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ renewal.payment.paymentMethod }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Items de Pago</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              <ul class="list-none p-0 m-0">
                <li
                  *ngFor="let item of renewal.payment.paymentItems; index as i"
                  class="py-1"
                >
                  <strong>{{ i + 1 }}. {{ item.description }}</strong> -
                  {{ item.valorTotal | currency:'COP':'symbol-narrow':'1.0-0' }}
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
